/**=========================================================
 * Module: app-docs.js
 * Spinner
 =========================================================*/

 App.directive('appDocs', function(){
    'use strict';
  
    return {
        templateUrl: '/app/views/partials/docs.html',
        controller: 'DocsController',
        restrict: 'E',
        replace: true,
        scope: {
          group: '@group',
          groupname: '@groupname',
          autoopen: '@autoopen',
          form: '=form',
          pastefield: '@pastefield'
        }
    };
  
  });